import { Person, IPerson } from '@/classes/InjuryForm/Person';

interface IStudent extends IPerson {
    gender?: string;
    dolId?: string;
    studentId?: number;
    jobCorpCenterId?: number;
}

class Student extends Person implements IStudent {
    public gender?: string;
    public dolId?: string;
    public studentId?: number;
    public jobCorpCenterId?: number;

    constructor(s: IStudent = {}) {
        super(s);
        this.gender = s.gender;
        this.dolId = s.dolId;
        this.studentId = s.studentId;
        this.jobCorpCenterId = s.jobCorpCenterId;
    }

    public isValid(): boolean {
        if (this.firstName !== undefined && this.firstName !== null && this.lastName !== undefined && this.lastName !== null
            && this.gender !== undefined && this.gender !== null) {
            if (this.firstName.length > 0 && this.lastName.length > 0 && this.gender.length > 0) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
}

export default Student;
export { Student, IStudent };
